module.exports = __webpack_public_path__ + "static/intro-left-flower-1ebc27b6e02164f089d4c9309638687f.png";